import request from '../../utils/request'

const state = {}

const actions = {
    // 登录
    userLogin({dispatch},data) {
        return new Promise((resolve)=>{
            request({
                url: `/login`,
                method: 'post',
                data
            }).then(data => {
                resolve(data);
            });
        })
    },

    // 退出登录
    userLogout({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/logout`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 上传文件
    fileUpload({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/file/common/upload`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}